import { useEffect, useRef } from "react";
export function usePageTracking(page: string, param: string, ready: boolean) {
  const last = useRef("");
  useEffect(() => {
    if (!ready) return;
    const key = `${page}/${param}`;
    if (last.current === key) return;
    last.current = key;
    if (page === "admin") return;
    void fetch("/api/analytics/events", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: crypto.randomUUID(),
        type: "page_view",
        page,
      }),
    }).catch(() => {});
  }, [page, param, ready]);
}
